import { gql } from 'apollo-boost'

const USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      name
      email
      roles {
        id
        name
      }
      email
      isActive
      loginDate
      modifiedDate
    }
  }
`

export default USER
